import { render, staticRenderFns } from "./prewviewDetail.vue?vue&type=template&id=52cc66ba&scoped=true&"
import script from "./prewviewDetail.vue?vue&type=script&lang=js&"
export * from "./prewviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./prewviewDetail.vue?vue&type=style&index=0&id=52cc66ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc66ba",
  null
  
)

export default component.exports